import { Route, useLocation, Routes } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import Login from "../Login";
import SignUp from "../SignUp";
import ForgotPassword from "../ForgotPassword";

import styles from "./styles.module.scss";

const AnimationApp = () => {
  const location = useLocation();

  return (
    <TransitionGroup>
      <CSSTransition
        key={location.pathname}
        timeout={800}
        classNames={{
          enter: styles["fade-enter"],
          exit: styles["fade-exit"],
          enterActive: styles["fade-enter-active"],
        }}
      >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default AnimationApp;
